// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { floatingMenuTooltip } from "@sc/App/Components/Menu/FloatingMenuTooltip";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

floatingMenuTooltip.tooltipContent = {
    css: css`
        z-index: ${getProp("theme.zIndex.tooltip")};
        background-color: ${color("common.ui1")};
        padding: 0;
        max-width: initial;
        border: none;
        border-radius: 4px;
        background-color: ${color("common.ui1")};
        min-width: ${({ minWidth }: any) => minWidth || 140}px;
        color: ${color("text.main")};
    `,
};